import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import CommandsPool from "@kaspernj/api-maker/build/commands-pool"
import memo from "set-state-compare/build/memo"
import React from "react"
import setLayout from "shared/set-layout"
import SuperAdmin from "@kaspernj/api-maker/build/super-admin"
import useCurrentUser from "@kaspernj/api-maker/build/use-current-user"
import usePressOutsideProps from "outside-eye/build/use-press-outside-props.js"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesSuperAdmin extends ShapeComponent {
  setup() {
    setLayout("admin")

    CommandsPool.current().globalRequestData.super_admin = true
  }

  render() {
    const currentUser = useCurrentUser()
    const pressOutsideProps = usePressOutsideProps()

    return (
      <View
        style={this.cache("rootViewStyle", {
          width: "100%",
          minHeight: "100vh"
        }, [])}
        {...pressOutsideProps}
      >
        <SuperAdmin currentUser={currentUser} />
      </View>
    )
  }
}))
